import { useCookies } from "react-cookie"

export const useAuthenticated = () => {
    const [cookies] = useCookies(['t']);

    const token = cookies.t || '';
    return !!token
}